module.exports = __webpack_public_path__ + "static/media/05-12.8181b8d5.png";